'use client'

import GraphicToolbar from './GraphicToolbar'
import GraphicPreview from './Preview/GraphicPreview'

export default function GraphicPanel() {
  return (
    <div className="flex h-full w-full flex-col overflow-hidden rounded-3xl bg-white shadow-lg">
      {/* Toolbar on top */}
      <div className="flex-shrink-0">
        <GraphicToolbar />
      </div>

      {/* Preview below */}
      <div className="min-h-0 flex-1">
        <GraphicPreview />
      </div>
    </div>
  )
}
